import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { DATE_FORMATS, formatDate, showError } from 'utils';
import ActionButton from 'components/ActionButton';
import { Loading } from 'components/loading/Loading';
import PieChart from './PieChart';
import { orderSourceReport } from 'services';

const OrderSourceReport = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<Record<string,any>[]>([]);
  const [pivotBy, setPivotBy] = useState<string>('count');
  const [startDate, setStartDate] = useState<string | null>(moment().subtract(30, 'days').toISOString());
  const [endDate, setEndDate] = useState<string | null>(moment().toISOString());
  
  const fetchOrderSourceReport = async () => {
    setLoading(true);
    const data = {
      startDate: formatDate(startDate, DATE_FORMATS.YYYY_MM_DD),
      endDate: formatDate(endDate, DATE_FORMATS.YYYY_MM_DD),
    };
    try {
      const response = await orderSourceReport(data);
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchOrderSourceReport();
  }, []);
  
  const getPieChart = () => <PieChart data={data} pivot={pivotBy} />;
  
  const getPivotDropdown = () => (
    <div className={styles['pivot-by-dropdown-container']}>
      <div className={styles['label']}>Pivot Chart By</div>
      <select
        className={'form-control'}
        onChange={e => setPivotBy(e.target.value)}
      >
        <option value={'count'}>Count</option>
        <option value={'totalSubtotals'}>Subtotal</option>
      </select>
    </div>
  );
  
  const getFilter = () => (
    <div className={styles['filter-container']}>
      <div className={''}>
        <div className={styles['label']}>Start Date</div>
        <div className={''}>
          <DatePicker
            className={'form-control'}
            disabled={loading}
            selected={startDate ? moment(startDate).toDate() : null}
            onChange={(e: any) => setStartDate(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
          />
        </div>
      </div>
      <div className={''}>
        <div className={styles['label']}>End Date</div>
        <div className={''}>
          <DatePicker
            className={'form-control'}
            disabled={loading}
            selected={endDate ? moment(endDate).toDate() : null}
            onChange={(e: any) => setEndDate(formatDate(moment(e), DATE_FORMATS.YYYY_MM_DD))}
          />
        </div>
      </div>
      <ActionButton
        text={'Submit'}
        active={!loading}
        isLoading={false}
        onClick={fetchOrderSourceReport}
        customClass={'m-0'}
      />
    </div>
  );
  
  return (
    <div>
      {loading && <Loading />}
      <div className={styles['header']}>
        <div className={styles['heading']}>Order Source Report</div>
      </div>
      {getFilter()}
      {getPivotDropdown()}
      {getPieChart()}
    </div>
  );
};

export default OrderSourceReport;